import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class Discount extends ModelBase {
  public static readonly type = 'Discount';
  public readonly type = Discount.type;

  @autoserializeAs('name')
  public name: string;

  @autoserializeAs('description')
  public description: string;

  @autoserializeAs('fixed_amount')
  public fixedAmount: number;

  @autoserializeAs('percentage')
  public percentage: number;

  public apply(originalPrice: number, amount: number): number {
    if (this.fixedAmount) {
      return Math.max(0, amount - this.fixedAmount);
    }
    if (this.percentage) {
      return Math.max(0, amount - (originalPrice * (this.percentage / 100.0)));
    }
    return amount;
  }
}
